import { Button, Row, Typography, useModal, useTheme } from "@commonlibs";
import clsx from "clsx";
import WarningToExternalLinkModal from "ui/common/components/feedback/WarningToExternalLinkModal/WarningToExternalLinkModal";
import { LinkIcon } from "ui/common/icons";
import { ButtonLinkProps, ButtonLinkTarget } from "../ButtonLink/ButtonLink.types";

function ButtonWarningLink<T extends ButtonLinkTarget = "self">({
    className: classNameProp,
    to,
    variant = "primary",
    fullWidth,
    style,
    label,
    Icon = LinkIcon,
    ...rest
}: ButtonLinkProps<T>) {
    const { spacing } = useTheme();
    const { showModal } = useModal();

    return (
        <Button variant={variant} style={style} className={clsx("button-link", classNameProp)} fullWidth={fullWidth} onClick={() => showModal(WarningToExternalLinkModal, { to: to})} {...rest}>
                <Row gap={spacing["4.5"]} alignItems="center" css={{ height: "100%" }}>
                    {Icon && <Icon fontSize="1.5rem" />}
                    <Typography variant="body2Strong">{label}</Typography>
                </Row>
        </Button>
    )
}

export default ButtonWarningLink;